import { ACCESS_LEVEL_ACCESS, accessLevelAccessLocale } from "Common/dictionaries/accessLevelAccess";
import Button from "Components/button";
import ScrolledDropdown, { TogglerWithFloatLabel } from "Components/scrolledDropdown";
import classNames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { accessIdKeySelector, accessIdTextSelector, accessOnTextSelector, userIdKeySelector, userIdTextSelector, userOnTextSelector } from "../../accessLevelsEditorPanel/utils/selectors";
import locale from "./accessLevelsCreator.locale";
const accessItems = map(ACCESS_LEVEL_ACCESS, a => ({
    Id: a,
    Name: accessLevelAccessLocale[a]
}));
export default function AccessLevelsCreator(props) {
    const [draft, setDraft] = useState(null);
    const newAccessLevel = useMemo(() => ({
        EntityType: props.entityType,
        EntityId: props.entityId
    }), [props.entityId, props.entityType]);
    useEffect(() => {
        props.accessLevelNew && setDraft(cloneDeep(newAccessLevel));
    }, [props.accessLevelNew, newAccessLevel]);
    const existingUsersIds = useMemo(() => props.data && map(props.data, "UserId"), [props.data]);
    const handleCancel = useCallback(() => {
        setDraft(cloneDeep(newAccessLevel));
    }, [newAccessLevel]);
    const handleSave = useCallback(() => {
        if (props.onSave && draft && draft.UserId) {
            props.onSave({ [draft.UserId]: draft });
        }
    }, [props.onSave, draft]);
    const handleUserChanged = useCallback((userId) => {
        if (!draft)
            return;
        const newDraft = cloneDeep(draft);
        newDraft.UserId = userId;
        newDraft.Changed = true;
        setDraft(newDraft);
    }, [draft]);
    const handleAccessLevelChanged = useCallback((access) => {
        if (!draft)
            return;
        const newDraft = cloneDeep(draft);
        newDraft.Access = access;
        newDraft.Changed = true;
        setDraft(newDraft);
    }, [draft]);
    return (React.createElement("div", { className: classNames("flex-single-column", props.className) },
        draft && (React.createElement("div", { className: "flex-greedy-block" },
            React.createElement(ScrolledDropdown, { items: props.users, keySelector: userIdKeySelector, textSelector: userIdTextSelector, visibilitySelector: userOnTextSelector(props.selfUserId || 0, existingUsersIds || []), onSelectedChanged: handleUserChanged, caption: "", label: locale.USER, selectedKey: draft === null || draft === void 0 ? void 0 : draft.UserId, className: "dropdown-toggle-flex-space-between", maxWidth: "100%", togglerClassName: "border-rounded-medium p-4-0", togglerComponent: React.createElement(TogglerWithFloatLabel, null), togglerHeight: 45, showSearchInputWhenItemsLengthIsGreaterThan: -1 }),
            React.createElement(ScrolledDropdown, { items: accessItems, keySelector: accessIdKeySelector, textSelector: accessIdTextSelector, visibilitySelector: accessOnTextSelector, onSelectedChanged: handleAccessLevelChanged, label: locale.ACCESS, caption: "", selectedKey: draft === null || draft === void 0 ? void 0 : draft.Access, className: "dropdown-toggle-flex-space-between mt-gap", maxWidth: "100%", togglerClassName: "border-rounded-medium p-4-0", togglerComponent: React.createElement(TogglerWithFloatLabel, null), togglerHeight: 45 }))),
        React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8 mt-24" },
            React.createElement(Button, { text: locale.CANCEL, onClick: handleCancel, disabled: !(draft === null || draft === void 0 ? void 0 : draft.Access) || !(draft === null || draft === void 0 ? void 0 : draft.UserId), className: "btn-h-m p-8-24" }),
            React.createElement(Button, { text: locale.ADD, className: "btn-primary btn-h-m p-8-24", disabled: !(draft === null || draft === void 0 ? void 0 : draft.Access) || !(draft === null || draft === void 0 ? void 0 : draft.UserId), onClick: handleSave }))));
}
